import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { DatepickerComponent } from '../datepicker-component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DropdownComponent } from '../dropdown-component';
import { EventEmitter } from '@angular/core';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgbdModalContent } from '../../alert-component';
import * as Parse from 'parse';

// import { MatTableDataSource } from '@angular/material';
// import { unescapeIdentifier } from '@angular/compiler';

@Component({
  selector: 'app-foodplan',
  templateUrl: './foodplan.component.html',
  styleUrls: ['./foodplan.component.css']
  
})
export class FoodplanComponent implements OnInit {

  foodplanForm : FormGroup;
  @Output() doneSubmiting = new EventEmitter();
  @ViewChild(DropdownComponent) planPicker: DropdownComponent;
  failedMessage : string;
  cookie : any;
  days = [];
  foodPlanSaved : boolean;
  submitted = false;
  successMessage: string;
  activityFailed: boolean;
  
  constructor(
    private router : Router,
    private _bkoffService: BackOffServiceService,
    private modalService: NgbModal,
    private formBuilder : FormBuilder,

  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }


  ngOnInit() {
    this.foodplanForm  =  this.formBuilder.group({
      foodName: ['', [Validators.required]],
      currentTimes: ['', [Validators.required, Validators.pattern("^[0-9]+$")]],
      futureTimes: ['', [Validators.required, Validators.pattern("^[0-9]+$")]],
      days: new FormArray([], minSelectedCheckboxes(1))
    });

    this.days = this.getDays();
    this.addDaysCheckboxes();

    this.router.events.subscribe((evt) => {
      window.scrollTo(0, 0)
    });
  }

    private addDaysCheckboxes() {
      this.days.map((o, i) => {
        const control = new FormControl(); // if first item set to true, else false
        (this.foodplanForm.controls.days as FormArray).push(control);
      });
  
  }

  get fmBuilder() { return this.foodplanForm.controls; }


  getFormControl(name:any) {
    return this.foodplanForm.get(name);
  }

  get formDay() { return <FormArray>this.foodplanForm.get('days');}

  get formData() { return <FormArray>this.foodplanForm.get('Data'); }
  
  getDays() {
         const today = new Date();

         for (var i = 0; i <= 6; i++) {
          this.days[i] = new Date(today.getTime() + (i * 86400000));
          console.log(this.days[i]);
        
      }
     return [
      { id: this.dateDBFormat(this.days[0]), name: this.dateFormat(this.days[0]), selected:false },
      { id: this.dateDBFormat(this.days[1]), name: this.dateFormat(this.days[1]), selected:false },
      { id: this.dateDBFormat(this.days[2]), name: this.dateFormat(this.days[2]), selected:false },
      { id: this.dateDBFormat(this.days[3]), name: this.dateFormat(this.days[3]), selected:false },
      { id: this.dateDBFormat(this.days[4]), name: this.dateFormat(this.days[4]), selected:false },
      { id: this.dateDBFormat(this.days[5]), name: this.dateFormat(this.days[5]), selected:false },
      { id: this.dateDBFormat(this.days[6]), name: this.dateFormat(this.days[6]), selected:false },
      { id: "", name: 'All Days', masterSelected:false },
    ];}

    private dateFormat(date: Date) {
      var monthString;
      var dayString;
      const day = date.getUTCDay();
      const dayWith = date && date.getDate() || -1;
      const dayWithZero = dayWith.toString().length > 1 ? dayWith : '0' + dayWith;
      const month = date.getMonth();
      
      switch (month) {
        case 0:
          monthString = "January";
          break;
        case 1:
          monthString = "February";
          break;
        case 2:
          monthString = "March";
          break;
        case 3:
          monthString = "April";
          break;
        case 4:
          monthString= "May";
          break;
        case 5:
          monthString = "June";
          break;
        case 6:
          monthString = "July";
          break;
        case 7:
          monthString = "August";
          break;
        case 8:
          monthString = "September";
          break;
        case 9:
          monthString = "October";
          break;
        case 10:
          monthString = "November";
          break;
        case 11:
          monthString =  "December";
          break;
      }  

      switch (day) {
        case 0:
          dayString = "Sunday";
          break;
        case 1:
          dayString = "Monday";
          break;
        case 2:
          dayString = "Tuesday";
          break;
        case 3:
          dayString = "Wednesday";
          break;
        case 4:
          dayString = "Thursday";
          break;
        case 5:
          dayString = "Friday";
          break;
        case 6:
          dayString = "Saturday";
          break;
      }  
      return `${dayWithZero} ${monthString} - ${dayString} `;
    }

    private dateDBFormat(date: Date) {
      var monthString;
      var dayString;
      const day = date.getUTCDay();
      const dayWith = date && date.getDate() || -1;
      const dayWithZero = dayWith.toString().length > 1 ? dayWith : '0' + dayWith;
      const month = date.getMonth() + 1;
      const monthWithZero = month.toString().length > 1 ? month : '0' + month;
      
      switch (day) {
        case 0:
          dayString = "Sunday";
          break;
        case 1:
          dayString = "Monday";
          break;
        case 2:
          dayString = "Tuesday";
          break;
        case 3:
          dayString = "Wednesday";
          break;
        case 4:
          dayString = "Thursday";
          break;
        case 5:
          dayString = "Friday";
          break;
        case 6:
          dayString = "Saturday";
          break;
      }  
      return `${monthWithZero}/${dayWithZero}`;
    }
    
  
  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.foodplanForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.foodplanForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }


  closeFoodPlan() {
    this.doneSubmiting.emit("saved");
    this.foodPlanSaved = true;
  }


  submitClick(){

    if (this.foodplanForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
        return;
    }
    this.submitted = true;

    var foodPlanData = new LogsData();

    foodPlanData.plannedTimes = this.foodplanForm.get(['futureTimes']).value;
    foodPlanData.currentTimes = this.foodplanForm.get(['currentTimes']).value;
    foodPlanData.foodplan = this.planPicker.selected;
    foodPlanData.plannedFood = this.foodplanForm.get(['foodName']).value;

    let arr = [true, true, true, true, true, true, true, false]
      console.log("form days " + this.foodplanForm.get(['days']).value);

      if(this.foodplanForm.get(['days']).value[7] == true){
        this.foodplanForm.setValue({
            foodName: foodPlanData.plannedFood,
            currentTimes: foodPlanData.currentTimes,
            futureTimes: foodPlanData.plannedTimes,
            days: arr
      });
    }

    const selectedDays = this.foodplanForm.value.days
      .map((v, i) => v ? this.days[i].id : null)
      .filter(v => v !== null);
    
    foodPlanData.days= selectedDays;

    console.log("test" + foodPlanData.foodplan + "test");
    if (this.planPicker.selected == ' ' || this.planPicker.selected === undefined) {
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.name = 'You have left a question unanswered';
      return;
    }

    this._bkoffService.setFoodPlan(foodPlanData).then((success)=>{
      this.doneSubmiting.emit("saved")
      this.foodPlanSaved = true;
      this.foodplanForm.reset();
      this.planPicker.selected = undefined;
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.name = 'Your food plan has been stored. It is on your checklist for you to keep track of and update.';
      modalRef.componentInstance.title = 'Success';
    }).catch(()=> {
     this.failedMessage  = "Error saving food plan "
     this.activityFailed = true
     this.sendUserFeedback(this.failedMessage)
     this.doneSubmiting.emit("failed")
     console.log(this.failedMessage)
    });

  }

  sendUserFeedback(message:string){
    
    const modalRef = this.modalService.open(NgbdModalContent);
    if (!this.foodPlanSaved){
      modalRef.componentInstance.name = 'Error saving data , please try again';
    }
   
  }

}

function minSelectedCheckboxes(min:Number) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}

